module.exports = __webpack_public_path__ + "epdf-app/dashboard/folder/folder-details-2x3eNLI5.html";